

import { CATATLOG_COUNT, IS_LOADING, UPDATE_COUNT } from "./mutation-types";

export default {

        [CATATLOG_COUNT]: (state, catalogCount)=>{
            state.catalogCount.categoryCount =  catalogCount.hasOwnProperty("CATEGORY") ? catalogCount.CATEGORY : 0
            state.catalogCount.subCategoryCount = catalogCount.hasOwnProperty("SUB_CATEGORY") ?  catalogCount.SUB_CATEGORY  : 0           
        },
        
        [UPDATE_COUNT]: (state, catalogCount)=>{
            state.catalogCount[catalogCount.fieldName] =  catalogCount.fieldValue
        },
        [IS_LOADING]: (state, value)=> {
            state.isLoading = value
        },
        

          
}
